import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import htmlEscaper$1, { htmlEscaper } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n\r\n<div class=\"campaignPropertiesSection\">\r\n</div>\r\n\r\n<div id=\"interest-rates-fees-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":13,"column":48},"end":{"line":13,"column":64}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"row collapse\" data-magellan-destination=\"interestRatesFeesCcModule\">\r\n  <h2 id=\"ratesAndFeesHeadline\"\r\n      class=\"small-12 column show-for-medium-up cnx-light\"\r\n      tabindex=\"0\">\r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"headline") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </h2>\r\n\r\n  <div class=\"small-12 column table-column\">\r\n    <div class=\"row table collapse\">\r\n      <div class=\"medium-12 column rates-table-body\">\r\n        <div class=\"row collapse rates-table-head\">\r\n          <div class=\"medium-6 large-3 column table-cols\">\r\n            <h3 class=\"header-style roboto-bold\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n            <div class=\"row-style-1\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          </div>\r\n          <div class=\"medium-6 large-3 column table-cols\">\r\n            <h3 class=\"header-style roboto-bold\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"1") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n            <div class=\"row-style-1\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"1") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          </div>\r\n          <div class=\"medium-6 large-3 column table-cols height-ctrl\">\r\n            <h3 class=\"header-style roboto-bold\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"2") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n            <div class=\"row-style-2\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"2") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          </div>\r\n          <div class=\"medium-6 large-3 column table-cols end height-ctrl\">\r\n            <h3 class=\"header-style roboto-bold\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"3") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n            <div class=\"row-style-2\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"3") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <p class=\"column small-12 tnc-foot-note\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"tncFootNote") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n  <p class=\"notes small-12 column\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"notes") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"lossGracePeriod") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":2},"end":{"line":40,"column":9}}})) != null ? stack1 : "")
    + "  <div class=\"small-12 column disclosure\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"disclosure") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p class=\"show-for-small-only small-12 column notes cnx-regular\">\r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"lossGracePeriod") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":43,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/interest-rates-fees-cc-module",
  "version": "4.0.1",
  "id": "interestRatesFeesCcModule",
  "containerID": "creditCardsInterestRatesFeesCcModule",
  "moduleName": "credit-cards-interest-rates-fees-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "interest-rates-fees-cc-module",
  "data": {
    "init": "interestRatesFeesCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        json,
        htmlEscaper
      },
      "partials": {
        "interest-rates-fees-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "interest-rates-fees-cc-partial": renderTemplate
  },
  "helpers": {
    json,
    htmlEscaper
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global spaParams sparta */

/*
 * interest-rates-fees-cc-module
 * module_js_id: interestRatesFeesCcModuleJS
 *
 * Copyright (c) 2017-12-4 removed
 */

/**
 * @export
 * @class interestRatesFeesCcModuleJS
 * @extends {Module}
 */
class interestRatesFeesCcModuleJS extends Module {
  /**
   * @param {object} options - options object
   * @param {object} context - context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('#interest-rates-fees-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['interest-rates-fees-cc-partial'];
    const magellanDest = target.dataset.init.substring(0, target.dataset.init.length - 2);
    target.dataset.magellanDestination = magellanDest;
  }

  /**
   * Initializes the module.
   * @memberof interestRatesFeesCcModuleJS
   * @returns {void}
   */
  init() {
    let campaignProperties;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const {
        target
      } = this.settings;
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams
      }, {
        helpers: {
          htmlEscaper: htmlEscaper$1
        }
      });
      target.querySelector('.campaignPropertiesSection').innerHTML = renderedTemplate;
      this.buildTnCAnchors();
      creditCardUtility.delegateEvent('click', '.spa-boa-tnc-window', creditCardUtility.handleTermsLink.bind(this), false, target);
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });
    });
  }

  /**
   * Look for anchor tags on page from PCM with #creditCardTnCAnchor
   * and build appropriate TnC link
   * @returns {void}
   */
  buildTnCAnchors() {
    const campaignId = this.Store.getData('campaign.campaignID');
    const poCode = this.Store.getData('campaign.poCode');
    const locale = this.Store.getData('campaign.locale');
    let tncUrl = `${spaParams.siteParams.siteRoot}/${spaParams.siteParams.tncUrl}`;
    if (sparta.language !== 'en') {
      tncUrl += `${sparta.language}/`;
    }
    tncUrl += `?campaignid=${campaignId}`;
    tncUrl += `&productoffercode=${poCode}`;
    tncUrl += `&locale=${locale}`;
    const anchors = this.settings.target.querySelectorAll('a[href="#creditCardTnCAnchor"]');
    Array.from(anchors).forEach(el => {
      el.setAttribute('href', tncUrl);
      el.classList.add('spa-boa-tnc-window');
      // Open in new tab on small devices
      if (this.Store.getData('currentMQ.mediaQueries.small-only')) {
        el.setAttribute('target', '_blank');
      }
    });
  }

  /**
   * Delegate event listeners to the module container so dom re-rendering will not double bind etc.
   *
   * @param {String} event - event to listen for
   * @param {String} selector - selector to delegate to target
   * @param {Function} handler - handler for event being listened for
   * @returns {void}
   */
  delegateEvent(event, selector, handler) {
    this.settings.target.addEventListener(event, function delegateTarget(e) {
      for (let {
        target
      } = e; target && target !== this; target = target.parentNode) {
        if (target.matches(selector)) {
          handler.call(target, e);
          break;
        }
      }
    }, false);
  }
}
registerModuleClass({
  moduleClass: interestRatesFeesCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { interestRatesFeesCcModuleJS as default, moduleConfig };
